import { ErrorMessage, useField } from "formik";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import "./TextField.css";

type Props = JSX.IntrinsicElements["input"] & {
  label: string;
  name: string;
  inputClassName?: string;
  tooltipMessage?: string;
};

const TextField = ({ label, name, inputClassName, tooltipMessage, ...props }: Props) => {
  const [field] = useField(name);

  const renderTooltip = (props: any) => (
    <Tooltip id="button-tooltip" {...props}>
      {tooltipMessage}
    </Tooltip>
  );

  return (
    <div>
      {tooltipMessage && (
        <OverlayTrigger delay={{ show: 250, hide: 400 }} overlay={renderTooltip}>
          <span id="text-field-tooltip-text" className="icofont icofont-question-circle mr-1"></span>
        </OverlayTrigger>
      )}
      <label htmlFor={name}>{label}</label>
      {props.type === "number" ? (
        <input
          className={`form-control${inputClassName ? " " + inputClassName : ""}`}
          {...field}
          {...props}
          value={field.value || undefined}
          autoComplete="off"
        />
      ) : (
        <input
          className={`form-control${inputClassName ? " " + inputClassName : ""}`}
          {...field}
          {...props}
          autoComplete="off"
        />
      )}

      <ErrorMessage component="div" name={field.name} className="error" />
    </div>
  );
};

export default TextField;
